// Define the form 'modes' supported by
// the form builder and form instances.
export enum FormModeEnum {
    DESIGN = 'design',
    PREVIEW = 'preview',
    INSTANCE = 'instance'
}
